import React from "react";
import Head from "next/head";

// 404 GLOBALE — « établissement non trouvé » (organisation introuvable).
// Rendue HORS thème (RouterPage, branche props.errorPage==="404") quand l'org
// elle-même n'est pas résolue : pas de config, pas de couleurs d'org, et PAS de
// LinguiClientProvider à ce niveau → texte statique. IMPORTANT : comme l'org
// n'est pas résolue, on ne connaît PAS la langue du visiteur → texte en ANGLAIS
// (langue neutre par défaut), surtout pas de français. Styles inline (aucune
// dépendance aux CSS /assets legacy). Identité Unisoft, fond clair pour la
// lisibilité du logo (texte noir + icône teal/bleu sur fond transparent).
// La 404 « page non trouvée » d'une org RÉSOLUE est gérée séparément par chaque
// thème (case "404" → Page404), dans les couleurs et la langue de l'org.
export default function Error404() {
    return (
        <div>
            <Head>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width,initial-scale=1.0" />
                <meta name="robots" content="noindex,nofollow" />
                <title>Organization not found</title>
                <link rel="icon" href={"/favicon-unisoft.png"} />
            </Head>

            <div style={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#f4f7fb",
                color: "#0f1b2d",
                fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
                padding: 24,
                textAlign: "center"
            }}>
                <div style={{ maxWidth: 520, width: "100%" }}>
                    <div style={{
                        fontSize: "clamp(72px, 16vw, 140px)",
                        fontWeight: 800,
                        lineHeight: 1,
                        letterSpacing: -2,
                        background: "linear-gradient(135deg, #1ba0b5 0%, #2d6cb5 100%)",
                        WebkitBackgroundClip: "text",
                        backgroundClip: "text",
                        WebkitTextFillColor: "transparent"
                    }}>404</div>

                    <h1 style={{ fontSize: "clamp(22px, 4vw, 30px)", fontWeight: 700, margin: "8px 0 0" }}>
                        Organization not found
                    </h1>

                    <p style={{ fontSize: 16, color: "#5a6a7e", margin: "14px auto 0", maxWidth: "44ch", lineHeight: 1.6 }}>
                        The address you entered doesn't match any community hosted on our
                        platform. It may be incorrect, or the organization is no longer active.
                    </p>

                    <a
                        href="https://unisoft.world"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            display: "inline-block",
                            marginTop: 28,
                            padding: "12px 28px",
                            background: "#2d6cb5",
                            color: "#fff",
                            borderRadius: 10,
                            fontSize: 15,
                            fontWeight: 600,
                            textDecoration: "none"
                        }}
                    >
                        Discover Unisoft
                    </a>

                    <div style={{ marginTop: 56 }}>
                        <img
                            src={"/logo-unisoft-vertical.png"}
                            alt="Unisoft"
                            style={{ height: 64, width: "auto", opacity: 0.95 }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
